import { UtilityText, WebLink } from 'component/text';
import { FormatParams, TLabel } from "util/stdtypes";

export type ReplaceZdfLinkTextProps = {
    type?: string;
    testID?: string;
    text?: string;
    url?: string;
    label?: TLabel;
    formatParams?: FormatParams;
    strong?: boolean;
};


// Same as LinkText but with the option to make the label bold
export function REPLACE_ZDF_LinkText({
    type = 'small',
    testID,
    text,
    url,
    label,
    formatParams,
    strong = false,
}: ReplaceZdfLinkTextProps) {
    return <WebLink url={url} testID={testID}>
        <UtilityText underline type={type} text={text} label={label} formatParams={formatParams} strong={strong}/>
    </WebLink>
}
